/**
 * Verifies if a specific route has already been approved
 */
export function isRouteApproved(
  route: uui.domain.client.rm.SchedulerRowRouteOrUnavailable,
  approvedPlans: uui.domain.client.rm.ApprovedPlans,
) {
  return !!approvedPlans[route.dateAsString]?.approvedRoutes[route.vehicleId] || route.edge > -1
}
